export const environment = {
  production: true,
  test: false,
  dev: false,
  environmentURL: "aHR0cHM6Ly9hcGkubnh0c29mdC5jb20vdjE=",
  packageVERSION: "Mi4xMC4w",
}
